import { FetchError } from "../errors/FetchError";
import { getParams, APP_SETTINGS } from "../utils";
import { } from "./authorization";
import {
  fetchApiImageAuth2,
  fetchApiImageAuth3,
  fetchFileWithAuthorization,
  fetchWithAuthorization,
  fetchWithAuthorizationToken,
} from "./fetch";

// Sin autenticación: se usa también antes de iniciar sesión (asistente de registro)
export const checkAcronymAvailability = async (acronym) => {
  try {
    const response = await fetch(
      `${APP_SETTINGS.API_URL}/public/check/acronym?search=${encodeURIComponent(acronym)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
        },
      }
    );
    const data = await response.json();
    return data?.code === true;
  } catch (error) {
    throw new FetchError(error, "Error checking acronym availability");
  }
};

export const fetchCondominiums = async (page, limit = 10, params) => {
  const { search, banned, start_date, end_date } = params || {};

  try {
    let url = `/condominium?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (banned !== undefined && banned !== null) url += `&banned=${banned}`;
    if (start_date) url += `&start_date=${start_date}`;
    if (end_date) url += `&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching condominiums");
  }
};

export const fetchCondominium = async (page, limit = 10, params) => {
  const { search, token, banned } = params;

  try {
    let url = `/condominium?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (typeof banned === "boolean") {
      url += `&banned=${banned}`;
    }
    const data = await fetchWithAuthorizationToken(url, token);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchLeads = async (page, limit = 10, params) => {
  try {
    const { search } = params;
    let url = `/public/leads?page=${page}&limit=${limit}`;
    const term = typeof search === "string" ? search.trim() : "";
    if (term) url += `&search=${encodeURIComponent(term)}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const fetchProperties = async (page, limit = 5, params) => {
  const { condominiumId, search } = params;

  try {
    let url = `/property?page=${page}&limit=${limit}`;
    if (condominiumId) {
      url += `&condominium_id=${encodeURIComponent(condominiumId)}`;
    }
    const term = typeof search === "string" ? search.trim() : "";
    if (term) url += `&search=${encodeURIComponent(term)}`;

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchReportsProperties = async (page, limit = 50, params) => {
  const { condominiumId, search } = params;

  try {
    let url = `/property/reports/properties?page=${page}&limit=${limit}`;
    if (condominiumId) {
      url += `&condominium_id=${encodeURIComponent(condominiumId)}`;
    }
    const term = typeof search === "string" ? search.trim() : "";
    if (term) url += `&search=${encodeURIComponent(term)}`;

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error");
  }
};

export const fetchOneProperty = async (params) => {
  const { propertyId } = params;

  try {
    const data = await fetchWithAuthorization(`/property/${propertyId}`);
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Property failed");
  }
};

export const deleteOneProperty = async (propertyId) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/${propertyId}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Property failed");
  }
};

export const createProperty = async (condominiumId, quantity) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/new/${condominiumId}`,
      { properties: quantity },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Property failed");
  }
};

export const findOne = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(`/condominium/${condominiumId}`);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in condominium");
  }
};

export const remove = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/${id}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to RemoveCondominium failed");
  }
};

export const ban = async (id, reason) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/ban/${id}`,
      { reason },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call failed to ban Condominium failed");
  }
};

export const active = async (id, description) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/unban/${id}`,
      { description },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to AciveCondominium failed");
  }
};

export const create = async (condominiumData) => {
  try {
    const data = await fetchWithAuthorization(
      "/condominium",
      condominiumData,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const createService = async (condominiumId, condominiumData) => {
  try {
    const data = await fetchWithAuthorization(
      `/charges/manual/${condominiumId}`,
      condominiumData,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const update = async (condominiumId, condominiumData) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/${condominiumId}`,
      condominiumData,
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const updateCondominiumImage = async (condominiumId, obj) => {
  try {
    const data = await fetchApiImageAuth2(
      `/condominium/picture/${condominiumId}`,
      obj,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to change condominium image failed");
  }
};

export const findOneConfig = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/config/${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in condominium");
  }
};

export const findConfigAsProperty = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/config/property/${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "An error ocurred during fetching config as property"
    );
  }
};

export const updateConfig = async (condominiumId, configData) => {
  try {
    let data;
    if (configData instanceof FormData) {
      data = await fetchApiImageAuth2(
        `/condominium/config/${condominiumId}`,
        configData,
        "POST"
      );
    } else {
      data = await fetchWithAuthorization(
        `/condominium/config/${condominiumId}`,
        configData,
        "PUT"
      );
    }
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create condominium failed");
  }
};

export const findAllProperties = async (condominiumId) => {
  try {
    const data = await fetchWithAuthorization(
      `/property?search=${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in condominium");
  }
};

export const movementsFunds = async () => {
  try {
    const data = await fetchWithAuthorization(
      `/condominium/account/movementsFunds`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in condominium");
  }
};

export const findCondominiumMovements = async (page, limit = 10, params) => {
  try {
    const { condominiumId, start_date, end_date, accountId, type } = params;
    let url = `/condominium/account/movements?page=${page}&limit=${limit}&condominium=${condominiumId}`;

    if (accountId) url += `&accountId=${accountId}`;
    if (type) url += `&type=${type}`;
    if (start_date && end_date)
      url += `&start_date=${start_date}&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "This is a custom error in condominium movements"
    );
  }
};

export const findCondominiumMovementsReseveFunds = async (
  page,
  limit = 10,
  params
) => {
  try {
    const { condominiumId, start_date, end_date, reserveFund } = params;
    let url = `/condominium/account/movementsReserveFunds?page=${page}&limit=${limit}&condominium=${condominiumId}&reserveFund=${reserveFund}`;
    if (start_date && end_date)
      url += `&start_date=${start_date}&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "This is a custom error in condominium movements"
    );
  }
};

export const findCondominiumMovementsProperty = async (
  page,
  limit = 10,
  params
) => {
  try {
    const { condominiumId, start_date, end_date } = params;
    let url = `/condominium/account/movementsProperty?page=${page}&limit=${limit}&condominium=${condominiumId}`;
    if (start_date && end_date)
      url += `&start_date=${start_date}&end_date=${end_date}`;

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "This is a custom error in condominium movements"
    );
  }
};

export const fetchCondominiumBalance = async (condominiumId) => {
  try {
    const url = `/condominium/account/get?condominium=${condominiumId}`;
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(
      error,
      "This is a custom error in condominium movements"
    );
  }
};
// HO-ISSUE-118: baja el archivo de propietarios con las unidades del
// condominio tal como están, para completar sobre eso y volver a subirlo.
// HO-TASK-249: en el formato que se pida, que son los mismos que acepta la
// carga (xlsx, csv, txt). Sin formato, el backend devuelve el .xlsx de antes.
export const exportPropertiesToExcel = async (condominiumId, format) => {
  try {
    const query = format ? `?format=${encodeURIComponent(format)}` : "";

    return await fetchFileWithAuthorization(
      `/property/export/${condominiumId}${query}`
    );
  } catch (error) {
    throw new FetchError(error, "Error al exportar propiedades a Excel");
  }
};

export const downloadInitialLoadTemplate = async (condominiumId, format = "xlsx") => {
  try {
    return await fetchFileWithAuthorization(
      `/condominium/initial-load/${condominiumId}/template?format=${encodeURIComponent(format)}`
    );
  } catch (error) {
    throw new FetchError(error, "No se pudo descargar el archivo de la carga inicial.");
  }
};

export const previewInitialLoad = async (condominiumId, formData) => {
  try {
    return await fetchApiImageAuth3(`/condominium/initial-load/${condominiumId}/preview`, formData, "POST");
  } catch (error) {
    throw new FetchError(error, "No se pudo revisar el archivo de la carga inicial.");
  }
};

export const applyInitialLoad = async (condominiumId, formData) => {
  try {
    return await fetchApiImageAuth3(`/condominium/initial-load/${condominiumId}`, formData, "POST");
  } catch (error) {
    throw new FetchError(error, "No se pudo guardar la carga inicial.");
  }
};

const initialDebtPath = (condominiumId, propertyId) =>
  `/condominium/initial-debt/${condominiumId}` + (propertyId ? `/property/${propertyId}` : "");

export const fetchInitialDebtVoidPreview = async (condominiumId, propertyId, periodId) => {
  try {
    const query = periodId ? `?period_id=${encodeURIComponent(periodId)}` : "";

    return await fetchWithAuthorization(`${initialDebtPath(condominiumId, propertyId)}/void-preview${query}`);
  } catch (error) {
    throw new FetchError(error, "No se pudo revisar la deuda inicial.");
  }
};

export const voidInitialDebt = async (condominiumId, propertyId, body) => {
  try {
    return await fetchWithAuthorization(`${initialDebtPath(condominiumId, propertyId)}/void`, body, "POST");
  } catch (error) {
    throw new FetchError(error, "No se pudo anular la deuda inicial.");
  }
};

export const importPropertiesFromExcel = async (condominiumId, file) => {
  try {
    const data = await fetchApiImageAuth3(
      `/property/import/${condominiumId}`,
      file,
      "POST",
      true
    );

    return data;
  } catch (error) {
    throw new FetchError(error, "Error al importar propiedades desde Excel");
  }
};

// HO-HU-37: buscar una cuenta de propietario ya existente (por usuario o
// cédula exactos) para vincularle una property, en vez de crearle una
// cuenta nueva.
export const findExistingOwner = async (identifier, propertyId) => {
  try {
    const propertyQuery = propertyId ? `&property_id=${encodeURIComponent(propertyId)}` : "";
    const data = await fetchWithAuthorization(
      `/property/owners/find?identifier=${encodeURIComponent(identifier)}${propertyQuery}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al buscar el propietario");
  }
};

export const linkPropertyToOwner = async (propertyId, authId) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/${propertyId}/link-owner`,
      { auth_id: authId },
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al vincular el propietario");
  }
};

// HO-ISSUE-117: deshace el ultimo vinculo activo de esta property, volviendo
// a ponerle la cuenta que tenia antes.
export const unlinkPropertyOwner = async (propertyId) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/${propertyId}/unlink-owner`,
      {},
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al desvincular el propietario");
  }
};

export const sendPropertiesCredentialsToN8n = async (condominiumId, propertyIds) => {
  try {
    const data = await fetchWithAuthorization(
      `/property/send-credentials/${condominiumId}`,
      propertyIds ? { property_ids: propertyIds } : null,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error al enviar credenciales a n8n");
  }
};
